import React, { Component } from 'react';
import RoomTypeContainer from './RoomTypeContainer';
export default class SearchResults extends Component {
    
    constructor(props) {
        super(props);
        this.state = { data: [], loading: true };
    }

    isAvailable(uid) {
        return this.state.data.includes(uid)
    }

    componentDidMount() {
        if (this.props.checkIn !== '' && this.props.nights !== '') {
            this.populateData();
        }
        
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.checkIn !== ''
            && this.props.nights !== ''
            && (prevProps.checkIn !== this.props.checkIn
                || prevProps.nights !== this.props.nights
                || prevProps.promoCode !== this.props.promoCode
                || prevProps.adults !== this.props.adults
                || prevProps.children != this.props.children
            )
        )
        {
            this.populateData();
        }
    }

    renderLayout() {

        var roomTypes = this.props.roomTypes;

        var selectedRooms = this.props.selectedRooms.filter(selectedRoom => selectedRoom.roomType);// !== null && selectedRoom.RoomType !== undefined);

        if (selectedRooms.length > 0 || this.props.selectedRooms.length > 1) {
            var reservationPropertyKey = this.props.propertyKey;
            roomTypes = roomTypes.filter(roomType => roomType.propertyKey === reservationPropertyKey);
        }

        var sortedRoomTypes = roomTypes.sort((a, b) => {
            if (this.isAvailable(b.uId) === this.isAvailable(a.uId)) {
                if (a.propertyKey === b.propertyKey) return 0;
                if (a.propertyKey === this.props.propertyKey) return -1;
                if (b.propertyKey === this.props.propertyKey) return 1;
                return 0;
            }
            
            return this.isAvailable(b.uId) - this.isAvailable(a.uId);
        });

        return (
            
            sortedRoomTypes.map((roomType) =>
                <RoomTypeContainer
                    key={roomType.id}
                    propertyId={this.props.propertyId}
                    propertyKey={this.props.propertyKey}
                    checkIn={this.props.checkIn}
                    nights={this.props.nights}
                    roomType={roomType}
                    promoCode={this.props.promoCode}
                    adults={this.props.adults}
                    children={this.props.children}
                    select={this.props.select}
                    available={this.isAvailable(roomType.uId)}
                    roomTypes={this.props.roomTypes}
                    rooms={this.props.rooms}
                    selectedRooms={this.props.selectedRooms}
                    mode={this.props.mode} //select/change/add
                                   />)
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderLayout();

        return (
            <div className='availability-results-container'>
                {contents}
            </div>
        );
    }

    async populateData() {
        let url = 'api/availability?propertyKey=' + this.props.propertyKey + '&from=' + this.props.checkIn +
            '&nights=' + this.props.nights; //add flag for main property only or filter data 

        fetch(url)
            .then((response) => {
                return response.json();
            })
            .then(data => {

                this.setState({
                    data: data,
                    loading: false
                });

               
            }).catch(error => {
                console.log(error);
            });
    }
}
